import createAction from '../../../../../util/createAction';

export const SHOW_JIRA_CORE_MODAL = 'upgrade/datacenter/SHOW_JIRA_CORE_MODAL';
export const showJiraCoreModal = createAction(SHOW_JIRA_CORE_MODAL);

export const HIDE_JIRA_CORE_MODAL = 'upgrade/datacenter/HIDE_JIRA_CORE_MODAL';
export const hideJiraCoreModal = () => ({ type: HIDE_JIRA_CORE_MODAL });
